import { createFileRoute } from '@tanstack/react-router';
import { MenusPage } from '../../features/content';

export const Route = createFileRoute('/admin/content/menus')({ component: MenusPage });
